import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Swal from 'sweetalert2';
import axios from 'axios';
import styled from 'styled-components';
import { addStudent } from '../../../actions/action_parent';

const SkeletonSelect = styled.div`
  width: 100%;
  height: 38px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 3px;
  margin-top: 10px;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

class BnlParentAddStudentForm extends Component {
  constructor(props) {
    super(props);

    this.STEPS = {
      form: 0,
      redirect: 1,
    };

    this.state = {
      activeComponent: this.STEPS.form,
      errors: {},
      firstName: '',
      grade: '',
      homeRoom: '',
      lastName: '',
      loading: false,
      teacherLastName: '',
      teacherSalutation: '',
      submitting: false,
      guardianRelationship: '',
      showRelationship: false,
      relationshipOptions: [],
      relationshipLoading: true,
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
  }

  cloneArray(array) {
    return array.slice();
  }

  handleOnChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  addStudent() {
    const that = this;
    const data = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
    };
  }

  handleOnSubmit(event) {
    event.preventDefault();
    if (!this.state.submitting) {
      const that = this;
      const data = {
        first_name: this.state.firstName,
        last_name: this.state.lastName,
      };

      // Include guardian relationship if shown and not empty
      if (this.state.showRelationship && this.state.guardianRelationship) {
        data.guardian_relationship = this.state.guardianRelationship;
      }

      this.setState(
        {
          errors: {},
          submitting: true,
        },
        () => {
          // Check if we're in a pre-shoot flow or a regular add student flow
          if (
            that.props.bnlPreShoot.preShoot ||
            that.props.bnlPreShoot.galleryPassword
          ) {
            // Pre-shoot flow with gallery assignment
            this.props.addStudent(data).then((response) => {
              that.setState({ submitting: false }, () => {
                if (response.payload.data) {
                  if (response.payload.data.errors) {
                    that.setState({ errors: response.payload.data.errors });
                  } else {
                    const { students } = this.props.parent;
                    const student_ids = students.map(
                      (student, i) => student.id,
                    );
                    that.props.history.push('/select-student');
                  }
                }
              });
            });
          } else {
            // Regular add student flow (no gallery)
            this.props
              .addStudent(data)
              .then((response) => {
                that.setState({ submitting: false }, () => {
                  if (response.payload.data) {
                    if (response.payload.data.errors) {
                      that.setState({ errors: response.payload.data.errors });
                    } else {
                      // Redirect to dashboard or my-account after adding student
                      that.props.history.push('/dashboard');
                    }
                  }
                });
              })
              .catch((error) => {
                that.setState({
                  submitting: false,
                  errors: {
                    student:
                      'An error occurred while adding the student. Please try again.',
                  },
                });
              });
          }
        },
      );
    }
  }

  renderHeader() {
    return (
      <div className="col-xs-12 col-md-12 col-lg-12">
        <div className="add-student__header--bnl text-center">
          Enter your student's name exactly as it appears in school records.
        </div>
        <p className="text-center add-student__header-description">
          Do not use nicknames or shortened versions. (e.g. Tim for Timothy)
        </p>
      </div>
    );
  }

  renderImagePreviews() {
    const images = this.props.bnlPreShoot.imageUrls.map((imageUrl) => (
      <li className="col-xs-3 col-md-3 col-lg-3" key={`image-${imageUrl}`}>
        <img
          className="bnl-dashboard__student-selection__img-previews__img"
          src={imageUrl}
        />
      </li>
    ));

    return images;
  }

  getBgColor() {
    if (this.state.firstName && this.state.lastName) {
      return 'bg--bnl-light-blue';
    }

    return 'bg--bnl-dark-grey';
  }

  renderSubmitButton() {
    const bgColor = this.getBgColor();

    if (this.props.bnlPreShoot.preShoot) {
      return (
        <input
          className={`add-student-form__button button--round-border ${bgColor} center-block`}
          value="Add Student"
          type="submit"
        />
      );
    }
    return (
      <input
        className={`add-student-form__button button--round-border ${bgColor} center-block`}
        value="Assign Gallery"
        type="submit"
      />
    );
  }

  renderForm() {
    const { errors } = this.state;
    const firstNameErrorClassName = errors.firstName ? '' : 'hidden';
    const lastNameErrorClassName = errors.lastName ? '' : 'hidden';
    const studentErrorClassName = errors.student ? '' : 'hidden';

    return (
      <div>
        {this.renderHeader()}
        <form onSubmit={this.handleOnSubmit} className="add-student-form">
          <div className="row">
            <div className="col-xs-12 col-md-4 col-md-offset-4">
              <input
                id="first-name"
                className="add-student-form__input border--round"
                name="firstName"
                onChange={this.handleOnChange}
                value={this.state.firstName}
                placeholder="First Name"
              />
              <div className={firstNameErrorClassName}>{errors.firstName}</div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-4 col-md-offset-4">
              <input
                id="last-name"
                className="add-student-form__input border--round"
                name="lastName"
                onChange={this.handleOnChange}
                value={this.state.lastName}
                placeholder="Last Name"
              />
              <div className={lastNameErrorClassName}>{errors.lastName}</div>
              <div className={studentErrorClassName}>{errors.student}</div>
            </div>
          </div>
          {(this.state.showRelationship || this.state.relationshipLoading) && (
            <div className="row">
              <div className="col-xs-12 col-md-4 col-md-offset-4">
                {this.state.relationshipLoading ? (
                  <SkeletonSelect />
                ) : (
                  <>
                    <select
                      className="add-student-form__input border--round"
                      name="guardianRelationship"
                      value={this.state.guardianRelationship}
                      onChange={this.handleOnChange}
                      style={{
                        marginTop: '10px',
                        paddingRight: '35px',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        backgroundImage:
                          "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\")",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 15px center',
                        backgroundSize: '20px',
                      }}
                    >
                      {this.state.relationshipOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </>
                )}
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-xs-12 col-md-4 col-md-offset-4">
              {this.renderSubmitButton()}
            </div>
          </div>
        </form>
        <ul className="row">{this.renderImagePreviews()}</ul>
      </div>
    );
  }

  renderRedirectModal() {
    const that = this;

    Swal.fire({
      title: 'Gallery Assigned!',
      text: 'Your gallery has been successfully assigned. You can now return to the dashboard and order.',
      showConfirmButton: true,
      showCancelButton: false,
      customClass: {
        confirmButton: 'add-student-redirect__go-to-dashboard',
        // confirmButton: 'add-student-redirect__go-to-order',
        // cancelButton: 'add-student-redirect__assign-gallery',
      },
      confirmButtonText: 'Back to Dashboard',
      // cancelButtonText: 'Add',
      // reverseButtons: true,
    }).then((res) => {
      if (res.value) {
        that.props.history.push('/dashboard');
      } else {
        that.props.history.push('/dashboard');
      }
    });
  }

  renderActiveComponent() {
    switch (this.state.activeComponent) {
      case this.STEPS.form:
        return this.renderForm();
      case this.STEPS.redirect:
        this.renderRedirectModal();
    }
  }

  componentWillReceiveProps(nextProps) {
    // redirect to signup step 2 when directly accessing "//add-student"
    // if current user is truthy but hasn't completed signup
    if (nextProps.auth.currentUserId && !nextProps.auth.signupCompleted) {
      this.props.history.replace('/signup/step-2');
    }
  }

  render() {
    const loading = this.state.loading ? 'loading' : 'hidden';

    return (
      <div>
        <div className={loading}>
          <div className="spinner" />
        </div>
        {this.renderActiveComponent()}
      </div>
    );
  }

  componentDidMount() {
    this.setState({ submitting: false });
    this.fetchRelationshipOptions();
  }

  fetchRelationshipOptions = async () => {
    try {
      // Let the API endpoint determine if relationships should be shown based on the current domain
      // The backend now uses the request domain to determine which company's options to show
      const response = await axios.get(
        '/api/v2/students/guardian_relationship_options',
        {
          headers: { publicToken: this.props.parent.publicToken },
        },
      );

      if (response.data.showRelationship) {
        this.setState({
          showRelationship: true,
          relationshipOptions: [
            { value: '', label: 'Relationship' },
            ...Object.entries(response.data.options).map(([value, label]) => ({
              value,
              label,
            })),
          ],
          relationshipLoading: false,
        });
      } else {
        this.setState({ relationshipLoading: false });
      }
    } catch (error) {
      this.setState({ relationshipLoading: false });
    }
  };
}

function mapStateToProps(state) {
  return {
    additionalData: state.additionalData,
    auth: state.auth,
    bnlPreShoot: state.bnlPreShoot,
    cart: state.cart,
    company: state.company,
    gallery: state.gallery,
    parent: state.parent,
    shoot: state.shoot,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addStudent,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BnlParentAddStudentForm);
